import {
  CardMedia, Grid, Stack, Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getCoverImage, getImageThumbUrl } from '@sda/utils/image';
import { Clamp } from '@client/components/common/Clamp';
import { GenreLabels } from '@client/components/Main/Profiles/GenreLabels';
import { VenueTypeLabel } from '@client/components/Main/Profiles/VenueTypeLabel';
import { getDateRange } from '@sda/utils/date';
import { getEventLocation } from '@sda/utils/string';
import { Spacer } from '@client/components/common/Spacer';
import { TextArea } from '@client/components/forms';
import { ProfileTypes } from '@sda/enums';
import type { FetchDataType } from '@sda/sdk/interfaces';
import type { Beacon } from '@sda/interfaces/beacon';

const useStyles = makeStyles()((theme) => ({
  cardMedia: {
    borderRadius: theme.radii.large,
    height: 95,
    width: 95,
  },
}));

export const MessageModal: React.FC<Beacon & FetchDataType> = ({ ...call }) => {
  const { classes } = useStyles();

  const { profileData: profile } = call;

  const hasGenre = Boolean(profile.primaryGenre) || Boolean(profile.secondaryGenre);
  const hasVenueType = Boolean(profile.venueType);

  let location = getEventLocation(call);

  if (!location && call.compiledAddress) {
    const parts = call.compiledAddress.split(',') || [];

    location = parts[0] || '';
  }

  return (
    <div>
      <Grid
        container
        spacing={1.5}
        wrap="nowrap"
      >
        <Grid item>
          <CardMedia
            className={classes.cardMedia}
            alt={profile.name}
            component="img"
            src={getCoverImage(profile.publicImageUrl, null, getImageThumbUrl)}
          />
        </Grid>

        <Grid item>
          <Clamp
            lines={1}
            variant="subtitle2"
            gutterBottom={!hasGenre && !hasVenueType}
          >
            {profile.name}
          </Clamp>

          {Boolean(hasGenre || hasVenueType) && (
            <>
              {Boolean(hasGenre) && (
                <GenreLabels
                  primaryGenre={profile.primaryGenre}
                  secondaryGenre={profile.secondaryGenre}
                  gutterBottom
                />
              )}

              {Boolean(hasVenueType) && (
                <VenueTypeLabel
                  venueType={profile.venueType}
                  gutterBottom
                />
              )}
            </>
          )}

          <Typography variant="body2">
            {getDateRange(call)}
          </Typography>

          <Typography>
            {location}
          </Typography>
        </Grid>
      </Grid>

      <Spacer />

      <Stack spacing={2}>
        <Typography color="textSecondary">
          {call.profileType === ProfileTypes.ACT ? (
            `Tell ${profile.name} about your space, which dates you're interested in, and what kind of show experience you envision.`
          ) : (
            `Tell ${profile.name} about your performance, which dates you're interested in, and what kind of show experience you envision.`
          )}
        </Typography>

        <TextArea
          name="message"
          label="Message"
          minRows={4}
          required
          fullWidth
        />
      </Stack>
    </div>
  );
};
